export const kathOndVla = {
  href: '/sam/organisationalunits/c000eaea-c451-2590-e044-d4856467bfb8',
};
